import { bool, number, object, string } from "prop-types"
import Transactions from "../LegacyRegistration/Transactions"
import { useEffect, useState } from "react"
import useTransactions from "./useTransactions"

const TransactionsTableWrapper = ({
  paths,
  registrationId,
  totalRefunds,
  totalPayments,
  totalDue,
  refundDue
}) => {
  const [mutatedPayments, setMutatedPayments] = useState([])
  const [mutatedRefunds, setMutatedRefunds] = useState([])
  const { transactions } = useTransactions(registrationId)

  const mutateTransactions = transactions => {
    if (!transactions) return

    const mutatedPaymentsArr = []
    const mutatedRefundsArr = []

    transactions.map(transaction => {
      const mutatedTransaction = {
        id: transaction.id,
        shortDescription: transaction.shortDescription,
        note: transaction.note,
        createdAt: transaction.createdAtForDisplay,
        amount: transaction.humanizedAmount,
        paths: {
          show: transaction.showPath
        }
      }

      if (transaction.type == "Refund") {
        mutatedRefundsArr.push({ ...mutatedTransaction, instrument: transaction.instrument })
      } else if (transaction.type == "Payment") {
        mutatedPaymentsArr.push(mutatedTransaction)
      }
    })

    setMutatedPayments(mutatedPaymentsArr)
    setMutatedRefunds(mutatedRefundsArr)
  }

  useEffect(() => {
    mutateTransactions(transactions)
  }, [transactions])

  return (
    <Transactions
      registration={{
        payments: mutatedPayments,
        refunds: mutatedRefunds,
        paths: paths,
        totalRefundsStr: totalRefunds,
        totalPaymentsStr: totalPayments,
        totalDueStr: totalDue,
        refundDueStr: refundDue,
        isRefundDue: !!refundDue
      }}
    />
  )
}

TransactionsTableWrapper.propTypes = {
  paths: object,
  registrationId: number,
  totalRefunds: string,
  totalPayments: string,
  totalDue: string,
  refundDue: bool
}

export default TransactionsTableWrapper
